// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import caseAreaEntity from './entities/case-area.json';
import caseAreaMenu from '../pages/case-area/menu.json';
import caseAreaFullForm from '../pages/case-area/forms/full.json';
import caseAreaContextForm from '../pages/case-area/forms/context.json';
import caseAreaMiniForm from '../pages/case-area/forms/mini.json';
import caseAreaLookupForm from '../pages/case-area/forms/lookup.json';
import caseAreaTableView from '../pages/case-area/views/table.json';
import caseAreaCardsView from '../pages/case-area/views/cards.json';
import caseAreaDashboardView from '../pages/case-area/views/dashboard.json';

/** Тип запису «Сфера відповідальності» зі сторінками пакета: меню, форми та подання з pages/case-area/. */
export const caseAreaDefinition: IRecordTypeDefinition = {
  ...caseAreaEntity,
  views: assembleViewSet({
      table: caseAreaTableView,
      cards: caseAreaCardsView,
      dashboard: caseAreaDashboardView,
  }),
  form: caseAreaFullForm,
  forms: { full: caseAreaFullForm, context: caseAreaContextForm, mini: caseAreaMiniForm, lookup: caseAreaLookupForm },
  menu: caseAreaMenu,
} as IRecordTypeDefinition;
